import React from "react";

function footer(props) {
  return (
    <footer className="bottom-0">
      <div class="mx-auto max-w-4xl  lg:max-w-7xl">
        <div class="border-t border-gray-200 py-3 text-left text-sm text-gray-500 sm:text-left">
          <span class="block sm:inline">
            © Zuper, Inc. All rights reserved.
          </span>
        </div>
      </div>
    </footer>
  );
}

export default footer;
